import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-217419c7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Organisation Details\n          ")
], -1));
const _hoisted_5 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_6 = { class: "col-span-6" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "businesscontact",
    class: "block text-sm font-medium text-gray-700"
}, "What is the name of the Business Contract that this role will\n                be working on? *", -1));
const _hoisted_8 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_9 = ["value", "disabled"];
const _hoisted_10 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_11 = { class: "col-span-6" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "employedin",
    class: "block text-sm font-medium text-gray-700"
}, "Which employing entity will this role be employed in? *", -1));
const _hoisted_13 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_14 = ["value", "disabled"];
const _hoisted_15 = ["value"];
const _hoisted_16 = ["value"];
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-1 text-sm text-red-500" }, [
    /*#__PURE__*/ _createElementVNode("b", null, "\n                  * The Employing Entity will be the Equans company that Cost\n                  Centre or Cost Object (Internal Order/WBS code) relates to.\n                  Please check with your local Finance support if you are unsure\n                  of this\n                ")
], -1));
const _hoisted_18 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_19 = { class: "col-span-6" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "division",
    class: "block text-sm font-medium text-gray-700"
}, "Which division will this role be employed in? *", -1));
const _hoisted_21 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_22 = ["value", "disabled"];
const _hoisted_23 = ["value"];
const _hoisted_24 = ["value"];
const _hoisted_25 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_26 = { class: "col-span-6" };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "sector",
    class: "block text-sm font-medium text-gray-700"
}, "Which sector will this role be employed in? *", -1));
const _hoisted_28 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_29 = ["value", "disabled"];
const _hoisted_30 = ["value"];
const _hoisted_31 = ["value"];
const _hoisted_32 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_33 = { class: "col-span-6" };
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "assigned",
    class: "block text-sm font-medium text-gray-700"
}, "Which cost centre will this role be assigned to? *", -1));
const _hoisted_35 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_36 = ["value", "disabled"];
const _hoisted_37 = ["value"];
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-1 text-sm text-red-500" }, [
    /*#__PURE__*/ _createElementVNode("b", null, "\n                  * Please ensure this Cost Code has been validated by your\n                  local Finance support before submitting this form\n                ")
], -1));
const _hoisted_39 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_40 = { class: "col-span-6" };
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "timeMaximo",
    class: "block text-sm font-medium text-gray-700"
}, "\n                Does time need to be captured in Maximo (CAFM system)? *\n              ", -1));
const _hoisted_42 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_43 = { class: "space-y-4" };
const _hoisted_44 = { class: "mt-1 flex items-start" };
const _hoisted_45 = { class: "h-5 flex items-center" };
const _hoisted_46 = ["disabled", "checked"];
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "timeMaximo",
        class: "text-sm font-medium text-gray-700"
    }, "Yes")
], -1));
const _hoisted_48 = { class: "flex items-start" };
const _hoisted_49 = { class: "h-5 flex items-center" };
const _hoisted_50 = ["disabled", "checked"];
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "timeMaximo",
        class: "text-sm font-medium text-gray-700"
    }, "No")
], -1));
const _hoisted_52 = {
    key: 0,
    class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4"
};
const _hoisted_53 = { class: "col-span-6" };
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "activityCode",
    class: "block text-sm font-medium text-gray-700"
}, "Please select the activity type from the list below.  If you are unsure of the correct\n                  activity type, please confirm with your Finance Business Partner\n              ", -1));
const _hoisted_55 = ["disabled", "value"];
const _hoisted_56 = ["value"];
const _hoisted_57 = {
    key: 0,
    class: "mt-2 text-sm font-medium text-gray-700"
};
const _hoisted_58 = ["disabled"];
const _hoisted_59 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_60 = { class: "col-span-6" };
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "costObject",
    class: "block text-sm font-medium text-gray-700"
}, "If required, which Cost Object (WBS code or Internal Order\n                Number) will this role be assigned too?", -1));
const _hoisted_62 = ["value", "disabled"];
const _hoisted_63 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_64 = { class: "col-span-6" };
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "category",
    class: "block text-sm font-medium text-gray-700"
}, "Which employee category will this role be assigned to? *", -1));
const _hoisted_66 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_67 = ["value", "disabled"];
const _hoisted_68 = ["value"];
const _hoisted_69 = { class: "col-span-6" };
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "jobFamily",
    class: "block text-sm font-medium text-gray-700"
}, "Which job family will this role be assigned to? *", -1));
const _hoisted_71 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_72 = ["value", "disabled"];
const _hoisted_73 = ["value"];
const _hoisted_74 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_75 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _hoisted_7,
                            _createTextVNode(),
                            (_ctx.v$.formData.businesscontact.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "\n                * " + _toDisplayString(_ctx.v$.formData.businesscontact.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "businesscontact",
                                type: "text",
                                name: "businesscontact",
                                value: _ctx.formData.businesscontact,
                                disabled: _ctx.showApprovalSteps,
                                autocomplete: "businesscontact",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-700", {
                                        'error-border': _ctx.v$.formData.businesscontact.$error,
                                        'border-red-500': _ctx.v$.formData.businesscontact.$error,
                                    }]),
                                onInput: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.businesscontact.$touch()))
                            }, null, 42, _hoisted_9)
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createTextVNode(),
                            (_ctx.v$.formData.employedin.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "\n                * " + _toDisplayString(_ctx.v$.formData.employedin.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "employedin",
                                name: "employedin",
                                autocomplete: "employed-in",
                                value: _ctx.formData.employedin,
                                disabled: _ctx.showApprovalSteps,
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-700", {
                                        'error-border': _ctx.v$.formData.employedin.$error,
                                        'border-red-500': _ctx.v$.formData.employedin.$error,
                                    }]),
                                onChange: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.employedin.$touch()))
                            }, [
                                (_ctx.showApprovalSteps)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.configData.ENTITIES, (entity) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: entity.entity,
                                            value: entity.entity
                                        }, _toDisplayString(entity.entity), 9, _hoisted_15));
                                    }), 128))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeEntities, (entity) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: entity.entity,
                                            value: entity.entity
                                        }, _toDisplayString(entity.entity), 9, _hoisted_16));
                                    }), 128))
                            ], 42, _hoisted_14),
                            _createTextVNode(),
                            _hoisted_17
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createTextVNode(),
                            (_ctx.v$.formData.division.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "\n                * " + _toDisplayString(_ctx.v$.formData.division.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "division",
                                name: "division",
                                autocomplete: "division",
                                value: _ctx.formData.division,
                                disabled: _ctx.showApprovalSteps,
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-700", {
                                        'error-border': _ctx.v$.formData.division.$error,
                                        'border-red-500': _ctx.v$.formData.division.$error,
                                    }]),
                                onChange: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.division.$touch()))
                            }, [
                                (_ctx.showApprovalSteps)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.configData?.DIVISIONS, (item) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: item.ID,
                                            value: item.NAME
                                        }, _toDisplayString(item.NAME), 9, _hoisted_23));
                                    }), 128))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeDivisions, (item) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: item.ID,
                                            value: item.NAME
                                        }, _toDisplayString(item.NAME), 9, _hoisted_24));
                                    }), 128))
                            ], 42, _hoisted_22)
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createTextVNode(),
                            (_ctx.v$.formData.sector.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "\n                * " + _toDisplayString(_ctx.v$.formData.sector.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "sector",
                                name: "sector",
                                value: _ctx.formData.sector,
                                disabled: _ctx.showApprovalSteps,
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-700", {
                                        'error-border': _ctx.v$.formData.sector.$error,
                                        'border-red-500': _ctx.v$.formData.sector.$error,
                                    }]),
                                onChange: _cache[6] || (_cache[6] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.sector.$touch()))
                            }, [
                                (_ctx.showApprovalSteps)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.sectors, (item) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: item.ID,
                                            value: item.NAME
                                        }, _toDisplayString(item.NAME), 9, _hoisted_30));
                                    }), 128))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeSectors, (item) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: item.ID,
                                            value: item.NAME
                                        }, _toDisplayString(item.NAME), 9, _hoisted_31));
                                    }), 128))
                            ], 42, _hoisted_29)
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                            _hoisted_34,
                            _createTextVNode(),
                            (_ctx.v$.formData.assigned.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_35, "\n                * " + _toDisplayString(_ctx.v$.formData.assigned.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "assigned",
                                name: "assigned",
                                autocomplete: "assigned",
                                value: _ctx.formData.assigned,
                                disabled: _ctx.showApprovalSteps,
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-700", {
                                        'error-border': _ctx.v$.formData.assigned.$error,
                                        'border-red-500': _ctx.v$.formData.assigned.$error,
                                    }]),
                                onChange: _cache[8] || (_cache[8] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.assigned.$touch()))
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.costCentres, (cc) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: cc.CostCentre,
                                        value: cc.CostCodeLookUp
                                    }, _toDisplayString(cc.CostCodeLookUp), 9, _hoisted_37));
                                }), 128))
                            ], 42, _hoisted_36),
                            _createTextVNode(),
                            _hoisted_38
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                            _hoisted_41,
                            _createTextVNode(),
                            (_ctx.v$.formData.timeMaximo.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_42, "\n                * " + _toDisplayString(_ctx.v$.formData.timeMaximo.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("div", _hoisted_45, [
                                            _createElementVNode("input", {
                                                id: "radio-maximo-yes",
                                                value: "Yes",
                                                name: "timeMaximo",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.timeMaximo === 'Yes',
                                                onChange: _cache[10] || (_cache[10] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.v$.formData.timeMaximo.$touch()))
                                            }, null, 42, _hoisted_46)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_47
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_48, [
                                        _createElementVNode("div", _hoisted_49, [
                                            _createElementVNode("input", {
                                                id: "radio-maximo-no",
                                                value: "No",
                                                name: "timeMaximo",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.timeMaximo === 'No',
                                                onChange: _cache[12] || (_cache[12] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[13] || (_cache[13] = ($event) => (_ctx.v$.formData.timeMaximo.$touch()))
                                            }, null, 42, _hoisted_50)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_51
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.formData?.timeMaximo === 'Yes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                                _hoisted_54,
                                _createTextVNode(),
                                _createElementVNode("select", {
                                    id: "activityCode",
                                    disabled: _ctx.showApprovalSteps,
                                    value: _ctx.formData.activityCode,
                                    name: "activityCode",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md w-full disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    onChange: _cache[14] || (_cache[14] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityCodes, ({ code, name }) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: code,
                                            value: code
                                        }, _toDisplayString(code) + " - " + _toDisplayString(name), 9, _hoisted_56));
                                    }), 128))
                                ], 40, _hoisted_55),
                                _createTextVNode(),
                                (!_ctx.showApprovalSteps)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_57, [
                                        _createTextVNode("\n                Find out more about Activity Codes\n                "),
                                        _createElementVNode("a", {
                                            href: "https://equans.sharepoint.com/:v:/r/sites/UKAdminExcellence/Shared%20Documents/Knowledge%20Bank/Managing%20Jobs/Activity%20type%20explained%20(video).mp4?csf=1&web=1&e=fxS67u",
                                            class: "text-indigo-500",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            disabled: _ctx.showApprovalSteps
                                        }, "\n                  here\n                ", 8, _hoisted_58)
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                            _hoisted_61,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "costObject",
                                type: "text",
                                name: "costObject",
                                value: _ctx.formData.costObject,
                                disabled: _ctx.showApprovalSteps,
                                autocomplete: "costObject",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-700",
                                onInput: _cache[15] || (_cache[15] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                            }, null, 40, _hoisted_62)
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                            _hoisted_65,
                            _createTextVNode(),
                            (_ctx.v$.formData.category.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_66, "\n                * " + _toDisplayString(_ctx.v$.formData.category.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "category",
                                name: "category",
                                value: _ctx.formData.category,
                                disabled: _ctx.showApprovalSteps,
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-700", {
                                        'error-border': _ctx.v$.formData.category.$error,
                                        'border-red-500': _ctx.v$.formData.category.$error,
                                    }]),
                                onChange: _cache[16] || (_cache[16] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[17] || (_cache[17] = ($event) => (_ctx.v$.formData.category.$touch()))
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: category,
                                        value: category
                                    }, _toDisplayString(category), 9, _hoisted_68));
                                }), 128))
                            ], 42, _hoisted_67)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_69, [
                            _hoisted_70,
                            _createTextVNode(),
                            (_ctx.v$.formData.jobFamily.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_71, "\n                * " + _toDisplayString(_ctx.v$.formData.jobFamily.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "jobFamily",
                                name: "jobFamily",
                                value: _ctx.formData.jobFamily,
                                disabled: _ctx.showApprovalSteps,
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-700", {
                                        'error-border': _ctx.v$.formData.jobFamily.$error,
                                        'border-red-500': _ctx.v$.formData.jobFamily.$error,
                                    }]),
                                onChange: _cache[18] || (_cache[18] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[19] || (_cache[19] = ($event) => (_ctx.v$.formData.jobFamily.$touch()))
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobFamilies, (family) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: family,
                                        value: family
                                    }, _toDisplayString(family), 9, _hoisted_73));
                                }), 128))
                            ], 42, _hoisted_72)
                        ])
                    ])
                ])
            ]),
            _createTextVNode(),
            (!_ctx.showApprovalSteps)
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                    _createElementVNode("button", {
                        class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                        onClick: _cache[20] || (_cache[20] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleResetForm && _ctx.handleResetForm(...args)), ["prevent"]))
                    }, "\n          Reset Form\n        "),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[21] || (_cache[21] =
                            //@ts-ignore
                            (...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
                    }, "\n          Next\n        ", 8, _hoisted_75)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
